import React from 'react';
import styled from 'styled-components';
import { Spacing } from '../../../components/Spacing';
import { media, theme } from '../../../components/themes/theme';
import { Headline4, Paragraph } from '../../atoms/Typography';
import { useMedia } from '../../../hooks/useMedia';
const TextImageWrapper = styled.div `
  text-align: center;
  max-width: 100%;

  /* This unblurs the images in all browsers. The images fed to this component via contentful are usually 1000+px and it leads to blurry images in some viewports. it's not perfect but definitely an improvement */
  /* stylelint-disable property-no-vendor-prefix,value-no-vendor-prefix */
  image-rendering: crisp-edges;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  -ms-interpolation-mode: nearest-neighbor;
`;
const Image = styled.img `
  display: block;
  max-width: 100%;
  height: auto;
  margin-bottom: 1.5rem;
  margin-left: auto;
  margin-right: auto;

  ${media.mobileL `
    max-width: 80%;
  `}

  ${media.tablet `
    max-width: 100%;
  `}
`;
const TextWrapper = styled.div `
  padding: 0 2rem;
  > p {
    max-width: 55ch;
    margin-left: auto;
    margin-right: auto;
  }

  ${media.tablet `
    padding: 0 1rem;
  `}
`;
const ImageWrapper = styled.div `
  max-width: 368px;
  margin: 0 auto;
`;
export function TextImage({ headline, headlineAsHTMLTag = 'h4', text = undefined, alt = '', src = '', srcSet = '', image = undefined, }) {
    const isLaptopLWidth = useMedia({ minWidth: theme.screenLaptopL });
    const isTabletWidth = useMedia({ minWidth: theme.screenTablet });
    return (React.createElement(TextImageWrapper, null,
        !image && React.createElement(Image, { src: src, srcSet: srcSet, alt: alt }),
        image && (React.createElement(Spacing, { pb: "spacing-m", px: isLaptopLWidth ? 'spacing-xxl' : undefined },
            React.createElement(ImageWrapper, null, image))),
        React.createElement(TextWrapper, null,
            React.createElement(Headline4, { asHTMLTag: headlineAsHTMLTag, align: "center", weight: 700 }, headline),
            text && (React.createElement(Spacing, { mt: "spacing-xs" },
                React.createElement(Paragraph, { size: isTabletWidth ? 3 : 2, align: "center" }, text))))));
}
